<!--
 * @Author: DESKTOP-90MI9K1\admin yangxiong
 * @Date: 2025-02-28 11:53:15
 * @LastEditors: DESKTOP-90MI9K1\admin yangxiong
 * @LastEditTime: 2025-04-28 17:19:17
 * @FilePath: \xypt-vue\src\components\loginMask\index.vue
 * @Description: 
 * 
 * Copyright (c) 2025 by 抠脚老汉, All Rights Reserved. 
-->
<template>
  <div>
    <el-dialog :close-on-click-modal="false" class="login-dialog" top="12%" :visible.sync="show" width="540px"
      @close="close" destroy-on-close>
      <div class="p-l-25 p-r-50">
        <h4 class="text-center font-18 color-3 m-b-25">登录</h4>
        <el-form ref="loginFormRef" :model="loginForm" label-width="80px" :rules="loginFormRules" v-loading="loginLoad">
          <el-form-item label="账号" prop="username">
            <el-input v-model="loginForm.username" @keyup.enter.native="handleMobileVerifyLogin"
              placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="mobileVerifyCode">
            <el-row>
              <el-col :span="16">
                <el-input v-model="loginForm.mobileVerifyCode" @keyup.enter.native="handleMobileVerifyLogin"
                  placeholder="请输入验证码"></el-input>
              </el-col>
              <el-col :span="8">
                <el-button v-if="codeTime <= 0" style="margin-left: 10px" plain
                  @click="handleSendLoginCode">发送验证码</el-button>
                <span style="margin-left: 10px" v-else>{{ codeTime }} 后可重新发送</span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button class="primary-btn" type="primary" style="width: 100%;"
              @click="handleMobileVerifyLogin">立即登录</el-button>
          </el-form-item>
          <el-form-item prop="checked">
            <div>
              <el-checkbox v-model="loginForm.checked" true-label="1" false-label="">阅读并同意</el-checkbox>
              <el-link type="primary" size="small" :underline="false"
                href="https://obs-huizhongbiao.obs.cn-southwest-2.myhuaweicloud.com/a794ebff4d78450e812a0bdcf%E6%8B%9B%E6%A0%87%E9%87%87%E8%B4%AD%E8%A1%8C%E4%B8%9A%E4%BF%A1%E7%94%A8%E5%B9%B3%E5%8F%B0%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.pdf"
                target="_blank">《招标采购行业信用平台用户协议》</el-link>
              <el-link type="primary" size="small" :underline="false"
                href="https://obs-huizhongbiao.obs.cn-southwest-2.myhuaweicloud.com/a794ebff46d32a0bdcf%E6%8B%9B%E6%A0%87%E9%87%87%E8%B4%AD%E8%A1%8C%E4%B8%9A%E4%BF%A1%E7%94%A8%E5%B9%B3%E5%8F%B0%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf"
                target="_blank">《招标采购行业信用平台隐私政策》</el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      loginForm: {},
      loginFormRules: {
        username: [{ required: true, message: '请输入账号！', trigger: 'blur' }],
        mobileVerifyCode: [{ required: true, message: '请输入验证码！', trigger: 'blur' }],
        checked: [{ required: true, message: '请先阅读并同意协议！', trigger: 'blur' }],
      },
      // 登录验证码
      codeTimer: null,
      codeTime: 0,
      loginLoad: false,
      show: false
    }
  },
  watch: {
    '$store.getters.loginShow' () {
      this.loginForm = {}
      this.show = true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    //处理发送登录验证码
    handleSendLoginCode () {
      if (this.codeTime > 0) return
      this.$refs.loginFormRef.validateField('username', async err => {
        if (err) return
        this.loginLoad = true
        let params = {
          username: this.loginForm.username,
          mobileVerifyType: 'verifyLogin'
        }
        const { code, msg } = await this.$api.user.getMSMCode(params)
        this.loginLoad = false
        if (code !== 200) return false
        this.$message.success(msg)
        this.codeTime = 60
        this.codeTimer = setInterval(() => {
          this.codeTime--
          if (this.codeTime === 0) {
            clearInterval(this.codeTimer)
          }
        }, 1000)
      })
    },
    // 处理验证码登录
    handleMobileVerifyLogin () {
      this.$refs.loginFormRef.validate().then(async () => {
        this.loginLoad = true
        let params = {
          username: this.loginForm.username,
          mobileVerifyCode: this.loginForm.mobileVerifyCode,
          loginType: 'XYPT'
        }
        this.$store.dispatch('user/login', params).then(({ code, data, msg }) => {
          this.loginLoad = false
          this.$store.dispatch('user/huiCoreLogin')
          this.show = false
        }).catch((err) => {
          this.loginLoad = false
        })
      }).catch(() => { })
    },
  }
}
</script>
<style lang="scss" scoped></style>